import { usePage } from "@inertiajs/react"
import { UserLayout } from "@/components/layouts/user-layout"
import { DirectoryScreen } from "@/features/user/directory-screen"
import type { DirectoryLocation } from "@/features/user/types"

type Props = {
  query: string
  results: DirectoryLocation[]
  nearby: boolean
}

export default function UserDirectoryIndex() {
  const { query, results, nearby } = usePage<Props>().props

  return (
    <UserLayout>
      <DirectoryScreen query={query} results={results} nearby={nearby} />
    </UserLayout>
  )
}
